/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { useAuthContext } from 'src/auth/hooks';
import { useGetSubscriptionByUser } from 'src/api/subscription';
import { SUBSCRIPTION_TYPES, SUBSCRIPTION_STATUS } from 'src/_mock';

import Label from 'src/components/label';

// ----------------------------------------------------------------------

export default function NavUpgrade() {
  const { user } = useAuthContext();

  const { subscription } = useGetSubscriptionByUser();

  const isBasic = subscription?.status !== SUBSCRIPTION_STATUS.EXPIRED && subscription?.productName === SUBSCRIPTION_TYPES.BASIC;

  const isPremium = subscription?.status !== SUBSCRIPTION_STATUS.EXPIRED && subscription?.productName === SUBSCRIPTION_TYPES.PREMIUM;

  const isEnterprise =
    subscription?.status !== SUBSCRIPTION_STATUS.EXPIRED && subscription?.productName === SUBSCRIPTION_TYPES.ENTERPRISE;

  const isBasicOrPremium = isBasic || isPremium;
  return (
    <Stack
      sx={{
        px: 2,
        py: 5,
        textAlign: 'center',
      }}
    >
      <Stack alignItems="center">
        <Box sx={{ position: 'relative' }}>
          <Avatar src={user?.avatarUrl} alt={user?.name} sx={{ width: 48, height: 48 }}>
            {user?.name?.charAt(0).toUpperCase()}
          </Avatar>

          <Label
            color={isBasic ? 'primary' : isPremium ? 'warning' : isEnterprise ? 'error' : 'success'}
            variant="filled"
            sx={{
              top: -6,
              px: 0.5,
              left: 40,
              height: 20,
              position: 'absolute',
              borderBottomLeftRadius: 2,
            }}
          >           
            {subscription?.status === SUBSCRIPTION_STATUS.EXPIRED ? 'Expired' : subscription?.productName ? subscription.productName : 'Free'}
          </Label>
        </Box>

        <Stack spacing={0.5} sx={{ mb: 2, mt: 1.5, width: 1 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.name}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.disabled' }}>
            {user?.email}
          </Typography>
        </Stack>

        {isBasicOrPremium ? (
          <Button
            LinkComponent={RouterLink}
            variant="contained"
            href={`${paths.dashboard.user.account}?tab=billing`}
            rel="noopener"
          >
            {isBasic ? 'Upgrade to Premium' : 'Upgrade to Enterprise'}
          </Button>
        ) : !isEnterprise ? (
          <Button
            LinkComponent={RouterLink}
            variant="contained"
            href={paths.pricing}
            rel="noopener"
          >
            Get Plan
          </Button>
        ) : (
          ''
        )}
      </Stack>
    </Stack>
  );
}
